import { render, staticRenderFns } from "./ParkingLots.vue?vue&type=template&id=21cf47ce&lang=pug&"
import script from "./ParkingLots.vue?vue&type=script&lang=ts&"
export * from "./ParkingLots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports